import React from 'react';
import PropTypes from 'prop-types';
import AccountPickerCardSelector from './AccountPickerCardSelector';
import accountPropTypes from '../../../states/accounts/propTypes';

const AccountPickerPage = ({
	pageLoading,
	accounts,
	listViewSelected,
	onFavouriteIconClick,
	onAccountClick,
	cardClass,
	layoutType,
	getIsAccountSelected,
	canAddMultiplePayees,
}) => (
	<div className="account-picker__items">
		{!pageLoading &&
			accounts.length > 0 &&
			accounts.map((account) => (
				<div className={`account-picker__items__item ${cardClass}`} key={account.id}>
					<AccountPickerCardSelector
						account={account}
						listViewSelected={listViewSelected}
						onAccountClick={onAccountClick}
						onFavouriteIconClick={onFavouriteIconClick}
						key={account.id}
						layoutType={layoutType}
						getIsAccountSelected={getIsAccountSelected}
						canAddMultiplePayees={canAddMultiplePayees}
					/>
				</div>
			))}
	</div>
);

AccountPickerPage.propTypes = {
	pageLoading: PropTypes.bool.isRequired,
	accounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	listViewSelected: PropTypes.bool.isRequired,
	onAccountClick: PropTypes.func,
	onFavouriteIconClick: PropTypes.func.isRequired,
	cardClass: PropTypes.string.isRequired,
	layoutType: PropTypes.string.isRequired,
	getIsAccountSelected: PropTypes.func,
	canAddMultiplePayees: PropTypes.bool,
};

export default AccountPickerPage;
